import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"


import { MessageDialog } from '../../../../framework/frontend/MessageDialog';
import { BlockFactory } from '../../../blockly/BlockFactory';
import { backToBlocklyPage } from "../functional/backToBlocklyPage";
import { useRoute, useRouter } from 'vue-router';
import { block_translation } from '../../../lang/BlockTranslation';

interface Prop{
  assetPath:string
  isVrm:boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ModelPlaneDetectArButton',
  props: {
    assetPath: null,
    isVrm: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  assetPath:string
  isVrm:boolean;
};


const route = useRoute();
const router = useRouter();

const t = block_translation;
const buttonName = t.to("AR","to_ar")


const addPlaneARElement = () => {
  const factory = new BlockFactory();
  const gltf = factory.getModelViewerSimpleModel(props.assetPath);
  factory.addWorkspaceAfterMounted(gltf);

  MessageDialog.info(
    '平面検知ARモデルブロックを追加しました。平面検知ARはシーンスタートを置かずに単独で実行してください。'
  );
  backToBlocklyPage(route,router);
};


return (_ctx: any,_cache: any) => {
  return (!__props.isVrm)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "btn btn-outline-dark",
        onClick: addPlaneARElement
      }, _toDisplayString(_unref(buttonName)) + " ", 1))
    : _createCommentVNode("", true)
}
}

})